import React, { useState } from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import styles from './CRMLayout.module.css';

const CRMLayout = ({ children, activeTab, setActiveTab }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className={styles.layoutContainer}>
      <div className={styles.mobileNav}>
        <div className={styles.mobileLogo}>Ananta CRM</div>
        <button 
          className={styles.hamburgerBtn} 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={(tab) => { setActiveTab(tab); closeMenu(); }} 
        isOpen={isMobileMenuOpen} 
        onClose={closeMenu}
      />
      
      {isMobileMenuOpen && <div className={styles.overlay} onClick={closeMenu}></div>}

      <main className={styles.mainContent}>
        {children}
      </main>
    </div>
  );
};

export default CRMLayout;
